import React, { createContext, useContext, useState } from 'react';
import { TOKEN_STORAGE_KEY } from '../constants/global';

interface ITokenStorage {
    token: string | undefined
    setToken: (token: ITokenStorage['token']) => void
}

export type TokenStorageType = ITokenStorage;

export const StoreContext = createContext<TokenStorageType>({ token: undefined, setToken: (token: ITokenStorage['token']) => { } });

export const useToken = () => {
    return useContext(StoreContext);
};

interface ISessionIdProps {
    children: any
}

function TokenStorage({ children }: ISessionIdProps) {
    const [token, setToken] = useState<ITokenStorage['token']>(sessionStorage.getItem(TOKEN_STORAGE_KEY) || undefined);

    const setAndSaveToken = (newToken: ITokenStorage['token']) => {
        if (newToken) sessionStorage.setItem(TOKEN_STORAGE_KEY, newToken);
        else sessionStorage.removeItem(TOKEN_STORAGE_KEY);

        setToken(newToken);
    };

    return (
        <StoreContext.Provider value={{ token, setToken: setAndSaveToken }}>
            {children}
        </StoreContext.Provider>
    );
}

export default TokenStorage;
